import React from 'react';
import './Image.scss';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

interface ImageViewProps {
  url: string;
  className?: string;
  preview?: boolean;
}

export default function ImageView({ url, className, preview = false }: ImageViewProps) {
  if (!preview) {
    return <img src={url} className={className} />;
  }

  return (
    <PhotoProvider>
      <PhotoView src={url}>
        <img src={url} className={className} />
      </PhotoView>
    </PhotoProvider>
  );
}
